// Разовая авторизация по кодовой фразе. Фраза вводится один раз, запоминается в
// браузере и шлётся с каждым запросом в заголовке X-Access-Key. Мост проверяет.

import { config, authHeaders } from '../config'

const KEY_STORAGE = 'clawapp:accessKey'

export function getAccessKey(): string {
  try {
    return localStorage.getItem(KEY_STORAGE) || ''
  } catch {
    return ''
  }
}

export function setAccessKey(k: string): void {
  try {
    localStorage.setItem(KEY_STORAGE, k)
  } catch {
    /* noop */
  }
}

export function clearAccessKey(): void {
  try {
    localStorage.removeItem(KEY_STORAGE)
  } catch {
    /* noop */
  }
}

function apiUrl(path: string): string {
  return config.apiBaseUrl ? config.apiBaseUrl + path : path
}

/** Требует ли бэкенд кодовую фразу (из /api/health). */
export async function fetchAuthRequired(): Promise<boolean> {
  try {
    const r = await fetch(apiUrl('/api/health'), { headers: { ...authHeaders() } })
    if (!r.ok) return false
    const j = await r.json()
    return !!j.authRequired
  } catch {
    return false
  }
}

/** Проверка фразы на бэкенде. true — подошла. */
export async function verifyKey(key: string): Promise<boolean> {
  try {
    const r = await fetch(apiUrl('/api/login'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ key }),
    })
    return r.ok
  } catch {
    return false
  }
}
